<template>
    <div class="taskDetail">
        <!-- 图片预览弹框 -->
        <van-image-preview v-model="imgPreviewShow" :images="previewImgList" :showIndex="false"></van-image-preview>
        <!-- 视频弹出框 -->
        <van-popup v-model="videoPreviewShow" :round="false">
            <div class="prevideoBox">
                <video controls="controls" autoplay="autoplay" width="100%" height="100%">
                    <source :src="previewVideoUrl" type="video/mp4">
                    <source :src="previewVideoUrl" type="video/ogg">
                    <source :src="previewVideoUrl" type="video/webm">
                </video>
            </div>
        </van-popup>
        <div class="title">{{detail.title}}</div>
        <div class="rowAc teacherLine">
            <div>{{detail.teacherName}}</div>
            <div class="taskInfo">发布于</div>
            <div class="taskInfo">{{changeTime(detail.submitDateTime.split(' ')[1],detail.submitDateTime.split(' ')[0])}}</div>
            <div class="line"></div>
            <div>学员</div>
            <div class="taskInfo">{{detail.studentName}}</div>
        </div>
        <div class="contentBox" :class="{'isFold': isFold}">
            <div class="taskContent" ref="taskContent">
                <div v-html="detail.content">
                <!-- 这是一条作业内容这是一条作业内容这是一条作业内容这是一条作业内容这是一条作业内容这是一 -->
                </div>
                <div class="fileBox flexRow">
                    <!-- 视频 -->
                    <div v-for="(item,index) in videoList" :key="'video'+index" class="fileItem" @click="previewVideo(item)">
                        <video  class="videoBox"  preload="auto" :poster="item+'?x-oss-process=video/snapshot,t_50,f_jpg,ar_auto'" :controls="false" :show-center-play-btn="false">
                           <source :src="item" type="video/mp4">
                            <source :src="item" type="video/ogg">
                            <source :src="item" type="video/webm">
                        </video>
                        <img src="../../assets/static/task/play-circle.png" class="playCircle" alt="">
                    </div>
                    <!-- 图片 -->
                    <div v-for="(item1,index1) in imgList" :key="'img'+index1" class="fileItem" @click="previewImg(index1)">
                        <van-image
                            width="100%"
                            height="100%"
                            fit="cover"
                            :src="item1"
                        />
                    </div>
                    <!-- 音频 -->
                    <div  v-for="(item2,index2) in voiceList" :key="'voice'+index2" class="fileItem rowJcAc voiceItem" @click="playVoice(item2)">
                        <img src="../../assets/static/task/musicIcon.svg" alt="" class="musicIcon">
                    </div>
                </div>
            </div>
            
            
        </div>
        <div class="foldBox fontMcA1 rowJc" @click="clickFold" v-if="isOver">
            <div>{{isFold ? '展开全部': '收起全部'}}</div>
            <div class=' foldIcon' :class="[isFold ? 'icon-arrow-down' : 'icon-arrow-up']"></div>
        </div>
    </div>
</template>
<script>
export default {
    props: ['detail'],
    data() {
        return {
            isFold: true, // 是否折叠
            imgList: [],
            videoList: [],
            voiceList: [],
            imgPreviewShow: false,
            videoPreviewShow: false, // 预览视频是否展示
            previewImgList: [], // 预览图片
            previewVideoUrl: '', // 预览视频路劲
            isOver: false, // 是否超出
            playVoiceUrl: '', // 当前播放音频的地址
        }
    },
    mounted() {
        console.log('作业详情：',this.detail)
        if(this.detail.imageUrl) {
            this.imgList = this.detail.imageUrl.split(',')
        }
        if(this.detail.videoUrl) {
            this.videoList = this.detail.videoUrl.split(',')
        }
        if(this.detail.voiceUrl) {
            this.voiceList = this.detail.voiceUrl.split(',')
        }
        this.$nextTick(()=> {
            var height = this.$refs.taskContent.offsetHeight
            if(height >= 42) {
                this.isOver = true
                console.log(height)
            }
        })
    },
    methods: {
        clickFold() {
            this.isFold = !this.isFold
        },
        // 点击播放音频
        playVoice(item) {
            this.$router.push({name: 'Voice', params: {url: item}})
        },
        // 预览视频
        previewVideo(item) {
            this.previewVideoUrl = item
            this.videoPreviewShow = true
        },
        // 根据开始时间，计算n分钟之后的结束时间
        getNTimeAfter(startTime,n) {
            var endTime = ''
            if(startTime != '') {
                var time = startTime
                var hour = parseInt(time.split(':')[0]) // 开始时间的小时
                var minute = parseInt(time.split(":")[1])  // 开始时间的分钟
                var h = Math.floor(n / 60) // 时长有多少小时
                var m = parseInt(n) % 60 // 时长有多少分钟
                
                if(minute + m >= 60) {
                    hour = hour==23 ? 0 : hour+1 
                    minute = m - (60-minute)
                }else {
                    minute += m
                }
                if(hour + h > 23) {
                    hour = Math.abs(24-(hour+h))
                }else {
                    hour += h
                }
                // console.log('kkkk:',hour,minute,h,m)
                endTime = this.changeNum(hour)+':'+this.changeNum(minute)
            }
            return endTime
        },
        // 对比两个日期是否相等
        comparisonDate(date1,date2) {
            var dateArr1 = date1.split('-')
            var dateArr2 = date2.split('-')
            return dateArr1[0] == dateArr2[0] && Number(dateArr1[1]) == Number(dateArr2[1]) && Number(dateArr1[2]) == Number(dateArr2[2])
        },
        // 转换时间
        changeTime(time,date1) {
            if(this.checkDate(date1) == '今日') {
                var time1 =  this.getNTimeAfter(time,10)
                var time1Num = Number(time1.split(':')[0]+time1.split(':')[1])
                var date = new Date()
                var nowTime = Number(String(this.changeNum(date.getHours()))+String(this.changeNum(date.getMinutes())))
                if(nowTime < time1Num) {
                    return '刚刚'
                }else {
                    return date1+' '+ time.split(':')[0]+":"+time.split(':')[1]
                }
            }else {
                return date1+' '+  time.split(':')[0]+":"+time.split(':')[1]
            }  
            
        },
        // 检查日期
        checkDate(date) {
            var today = new Date()
            var todayStr = today.getFullYear()+'-'+(today.getMonth()+1)+'-'+today.getDate()
            var yesterday = this.jumpNumDay(new Date(),-1,'-')
            if(this.comparisonDate(todayStr,date)) {
                return '今日'
            }else if(this.comparisonDate(yesterday,date)) {
                return '昨日'
            }else {
                return false
            }
        },
        // 向前/向后num天
        jumpNumDay(date,num,linkStr='-') {
            var date1 = new Date(date.getTime()+(num*24*60*60*1000))
            return date1.getFullYear()+linkStr+this.changeNum(date1.getMonth()+1)+linkStr+this.changeNum(date1.getDate())
        },
        // 转换数字
        changeNum(num) {
            if(num >= 10) {
                return num
            }else {
                return '0'+num
            }
        },
        // 预览图片
        previewImg(index) {
            this.previewImgList = [this.imgList[index]]
            this.imgPreviewShow = true
        }
    }
}
</script>
<style lang="scss" scoped>
/deep/ {
    .van-popup {
        border-top-left-radius: 0 !important;
        border-top-right-radius: 0 !important;
        width: 100%;
        height: 50%;
    }
}
.taskDetail {
    background: #ffffff;
    border-radius: .12rem;
    padding: .12rem .16rem;
    box-sizing: border-box;
    .title {
        font-weight: 500;
        font-size: .16rem;
        line-height: .24rem;
        color: #333843;
        margin-bottom: .06rem;
    }
    .fold {
        max-height: 1.59rem;
        overflow: hidden;
    }
    .teacherLine {
        font-size: .12rem;
        line-height: .18rem;
        color: #5A6073;
        margin-bottom: .12rem;
        flex-wrap: wrap;
        .taskInfo {
            color: #9EA5BB;
            margin-left: 4px;
        }
        .line {
            width: 2px;
            height: .12rem;
            background: #9EA5BB;
            margin: 0 .1rem;
        }
    }
}
.fileBox {
    flex-wrap: wrap;
}
.videoBox {
    width: .72rem;
    height: .72rem;
}
.fileItem {
    position: relative;
    width: .72rem;
    height: .72rem;
    border-radius: .04rem;
    overflow: hidden;
    position: relative;
    margin-top: .2rem;
    margin-right: .1rem;
    border: 1px solid #E8EBF3;
}
.playCircle {
    width: .32rem;
    height: .32rem;
    position: absolute;
    left: 50%;
    top: 50%;
    margin-top: -.16rem;
    margin-left: -.16rem;
}
.contentBox {
    line-height: .21rem;
    font-size: .14rem;
    color: #5A6073;
}
.isFold {
    max-height: 42px;
    overflow: hidden;
}
.foldBox {
    line-height: .2rem;
    font-size: .14rem;
    padding-top: .12rem;
}
.foldIcon {
    font-size: .2rem;
    margin-left: 2px;
}
.prevideoBox {
    width: 100%;
    height: 100%;
}
// 富文本框样式
/deep/ {
    h1 {
        font-size: 2em !important;
    }
    h1 {
        font-size: 2em !important;
    }
    h2 {
        font-size: 1.5em !important;
    }
    h3 {
        font-size: 1.17em !important;
    }
    h4 {
        font-size: 1em !important;
    }
    h5 {
        font-size: 0.83em !important;
    }
    p {
        font-size: 1em !important;
    }
    ul {
        list-style-type: disc;;
    }
    ol {
        list-style-type: decimal
    }
    /*表情菜单样式*/
    .eleImg{
        cursor: pointer;
        display: inline-block;
        font-size: 18px;
        padding: 0 3px;
    }
    * {
        padding: 0;
        margin: 0;
        box-sizing: border-box;
    }
    /*分割线样式*/
    hr{
        cursor: pointer;
        display: block;
        height: 0px;
        border: 0;
        border-top: 3px solid #ccc;
        margin: 20px 0;
    }
    .w-e-toolbar,
    .w-e-text-container,
    .w-e-menu-panel {
        padding: 0;
        margin: 0;
        box-sizing: border-box;
        background-color: #fff;
        
    }

    .w-e-clear-fix:after {
        content: "";
        display: table;
        clear: both;
    }

    .w-e-drop-list-item {
        position: relative;
        top: 1px;
        padding-right: 7px;
        color: #333 !important;
    }

    .w-e-drop-list-tl {
        padding-left: 10px;
        text-align: left;
    }
    .w-e-toolbar {
    .w-e-droplist {
        position: absolute;
        left: 0;
        top: 0;
        background-color: #fff;
        border: 1px solid #f1f1f1;
        border-right-color: #ccc;
        border-bottom-color: #ccc;

        .w-e-dp-title {
            text-align: center;
            color: #999;
            line-height: 2;
            border-bottom: 1px solid #f1f1f1;
            font-size: 13px;
        }

        ul.w-e-list {
            list-style: none;
            line-height: 1;

            li.w-e-item {
                color: #333;
                padding: 5px 0;

                &:hover {
                    background-color: #f1f1f1;
                }
            }
        }
        
        ul.w-e-block {
            list-style: none;
            text-align: left;
            padding: 5px;

            li.w-e-item {
                display: inline-block;
                padding: 3px 5px;

                &:hover {
                    background-color: #f1f1f1;
                }
            }
        }
    }
    }
    
    
    .w-e-text-container {
    position: relative;

    .w-e-progress {
        position: absolute;
        background-color: #1e88e5;
        top: 0;
        left: 0;
        height: 1px;
    }

    .placeholder {
        color: #D4D4D4;
        position: absolute;
        font-size: 11pt;
        line-height: 22px;
        left: 10px;
        top: 10px;
        user-select: none;
        z-index: -1;
    }
}
.musicIcon {
    width: .26rem;
    height: .26rem;
}
.voiceItem {
    background: #36CFC9;
}
// .w-e-text {
    // padding: 0 10px;
    // overflow-y: auto;

    p,h1,h2,h3,h4,h5,table,pre {
        margin: 10px 0;
        line-height: 1.5;
    }

    ul, ol {
        margin: 10px 0 10px 20px;
    }

    blockquote {
        display: block;
        border-left: 8px solid #d0e5f2;
        padding: 5px 10px;
        margin: 10px 0;
        line-height: 1.4;
        font-size: 100%;
        background-color: #f1f1f1;
    }

    code {
        display: inline-block;
        background-color: #f1f1f1;
        border-radius: 3px;
        padding: 3px 5px;
        margin: 0 3px;
    }

    pre {

        code {
            display: block;
        }
    }

    table {
        border-top: 1px solid #ccc;
        border-left: 1px solid #ccc;

        td,th {
            border-bottom: 1px solid #ccc;
            border-right: 1px solid #ccc;
            padding: 3px 5px;
            min-height: 30px;
        }

        th {
            border-bottom: 2px solid #ccc;
            text-align: center;
            background-color: #f1f1f1;
        }
    }

    &:focus {
        outline: none;
    }

    img {
        cursor: pointer;

        &:hover {
            box-shadow: 0 0 5px #333;
        }
    }

    .w-e-todo {
        margin:0 0 0 20px;
        li {
            list-style:none;
            font-size: 1em;
            span:nth-child(1) {
                position: relative;
                left: -18px;
                input {
                    position: absolute;
                    margin-right:3px;
                }
                // 防止其他样式通过属性选择器重置input样式
                input[type=checkbox] {
                    top: 50%;
                    margin-top: -6px;
                }
            }
        }
    }
// }

.w-e-tooltip {
    position: absolute;
    display: flex;
    color: #f1f1f1;
    background-color: rgba(0,0,0,.75);
    box-shadow: 0 2px 8px 0 rgba(0,0,0,.15);
    border-radius: 4px;
    padding: 4px 5px 6px;
    justify-content: center;
    align-items: center;
}
// 下箭头
.w-e-tooltip-up::after {
    content: "";
    position: absolute;
    top: 100%;
    left: 50%;
    margin-left: -5px;
    border: 5px solid rgba(0,0,0,0);
    border-top-color: rgba(0,0,0,.73);
}
// 上箭头
.w-e-tooltip-down::after {
    content: "";
    position: absolute;
    bottom: 100%;
    left: 50%;
    margin-left: -5px;
    border: 5px solid rgba(0,0,0,0);
    border-bottom-color: rgba(0,0,0,.73);
}
.w-e-tooltip-item-wrapper {
    cursor: pointer;
    font-size: 14px;
    margin: 0 5px;

    &:hover {
        color: #ccc;
        text-decoration: underline;
    }
}

.w-e-menu-tooltip {
  position: absolute;
  display: flex;
  color: #f1f1f1;
  background-color: rgba(0, 0, 0, .75);
  box-shadow: 0 2px 8px 0 rgba(0, 0, 0, .15);
  border-radius: 4px;
  padding: 4px 5px 6px;
  justify-content: center;
  align-items: center;
}
// 下箭头
.w-e-menu-tooltip-up::after {
  content: "";
  position: absolute;
  top: 100%;
  left: 50%;
  margin-left: -5px;
  border: 5px solid rgba(0, 0, 0, 0);
  border-top-color: rgba(0, 0, 0, .73);
}

.w-e-menu-tooltip-item-wrapper {
  font-size: 14px;
  margin: 0 5px;
}

}

</style>